import React, { FC } from "react";

import { faCalendarAlt } from "@fortawesome/pro-solid-svg-icons/faCalendarAlt";
import { faExpand } from "@fortawesome/pro-solid-svg-icons/faExpand";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import DateRange, {
  StandardAndCustomRangeType,
} from "@mapmycustomers/shared/types/range/DateRange";
import { Button } from "@mapmycustomers/ui";

import formatDateRange from "@app/util/stackRank/formatDateRange";

import DateRangeSelector from "./DateRangeSelector";
import styles from "./Subtitle.module.scss";

export interface SubtitleProps {
  dateRange: DateRange;
  dateRangeType: StandardAndCustomRangeType;
  onChange?: (payload: { dateRange: DateRange; dateRangeType: StandardAndCustomRangeType }) => void;
  onShowDrillDown?: () => void;
}

const Subtitle: FC<SubtitleProps> = ({ dateRange, dateRangeType, onChange, onShowDrillDown }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.line1}>
        <span className={styles.title}>
          {intl.formatMessage({
            id: "dashboard.sidebar.subtitle",
            defaultMessage: "Stack Rank",
            description: "Subtitle of the dashboard sidebar",
          })}
        </span>
        <Button
          className={styles.fullScreenButton}
          data-action-id="stack-rank-full-screen"
          onClick={onShowDrillDown}
          type="link"
        >
          {intl.formatMessage(
            {
              id: "dashboard.sidebar.fullScreen",
              defaultMessage: "Full Screen {icon}",
              description: "Title of the FullScreen button on Dashboard's sidebar",
            },
            {
              icon: <FontAwesomeIcon icon={faExpand} />,
            }
          )}
        </Button>
      </div>
      <div className={styles.line2}>
        <span className={styles.dateRange}>{formatDateRange(dateRange)}</span>
        <DateRangeSelector dateRange={dateRange} dateRangeType={dateRangeType} onChange={onChange}>
          <Button
            className={styles.changeButton}
            icon={<FontAwesomeIcon icon={faCalendarAlt} />}
            iconOnly
            type="filled"
          />
        </DateRangeSelector>
      </div>
    </div>
  );
};

export default Subtitle;
